module.exports = __webpack_public_path__ + "static/img/tc2.5cc2896.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/home/imgs/tc2.png
// module id = HV4J
// module chunks = 1